import { Box, TextField } from "@material-ui/core";
import { useState } from "react";
import { Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Rating from '@material-ui/lab/Rating';
import StarIcon from "@material-ui/icons/Star";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: "relative",
      "& .MuiTextField-root": {
        "& p": {
          marginLeft: "0px",
          marginTop: "4px",
        },
      },
      "& .MuiInputBase-input": {
        fontSize: 16,
        "&::placeholder": {
          color: "#808080",
          opacity: 1,
        },
      },
      "& .MuiOutlinedInput-multiline": {
        padding: 0,
      },
    },
  })
);

function CustomInput(props: any) {
  const classes = useStyles();
  const [wordCount, setWordcount] = useState(0);

  return (
    <>
      {/* <form className={classes.root} noValidate autoComplete="on"> */}
      <div className={classes.root}>
        <Rating
          classes={
            {
              // root: "classes-root", // class name, e.g. `root-x`
              // disabled: "classes-disabled", // class name, e.g. `disabled-x`
              // label:"classes-formControl"
            }
          }
          precision={1}

          className="h4"
          fullWidth
          margin="8px"
          onChange={(e: any) => {
          
            var dataIndex = props.dataIndex == undefined ? 0 : props.dataIndex;
           
            props.parentcall &&
              props.parentcall(e.target.value, props.id, dataIndex);
          }}
          emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}

          {...props}
        />
   
      </div>
      {/* </form> */}
    </>
  );
}

export default CustomInput;
